import { Component, Prop, Vue } from "vue-property-decorator";
import { CreateElement } from "vue";

@Component
export default class Selection extends Vue {
  render(h: CreateElement) {
    return (
      <v-container fluid class="fill-height">
        <div style={{ width: "100%" }}>
          <v-row
            style={{ height: "100px", marginBottom: "100px" }}
            class="justify-center"
            align="center"
          >
            <span
              style={{
                display: "flex",
                alignItems: "center",
                color: "#1A1F45"
              }}
            >
              <v-img
                src={require("@/../public/ms-icon-310x310.png")}
                width="125px"
              ></v-img>
              <p
                style={{
                  marginBottom: "0px",
                  marginLeft: "10px",
                  fontSize: "64px"
                }}
              >
                <span style={{ fontWeight: "bold" }}>Balance</span>
                <span>AI</span>
                <span
                  style={{
                    fontSize: "12px",
                    display: "block",
                    marginTop: "-15px",
                    marginLeft: "3px",
                    color: "#1c214a"
                  }}
                >
                  21<sup>st</sup> century literacy and language assessment tool
                </span>
              </p>
            </span>
          </v-row>
          <v-row justify="center">
            <v-col cols="3">
              <v-card class="elevation-12" to={{ name: "consent-teacher" }}>
                <v-toolbar color="#82B1FF">
                  <v-spacer></v-spacer>
                  <v-toolbar-title>Teacher</v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-actions class="justify-center">
                  <v-btn fab icon x-large to={{ name: "consent-teacher" }}>
                    <v-icon x-large>mdi-file-document-box</v-icon>
                  </v-btn>
                </v-card-actions>
                <v-card-text>If you are a teacher, click here.</v-card-text>
                <v-row></v-row>
              </v-card>
            </v-col>
            <v-col cols="3">
              <v-card class="elevation-12" to={{ name: "consent-parent" }}>
                <v-toolbar color="secondary">
                  <v-spacer></v-spacer>
                  <v-toolbar-title>Parent</v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-actions class="justify-center">
                  <v-btn fab icon x-large to={{ name: "consent-parent" }}>
                    <v-icon x-large>mdi-file-document-box</v-icon>
                  </v-btn>
                </v-card-actions>
                <v-card-text>If you are a parent, click here.</v-card-text>
              </v-card>
            </v-col>
            <v-col cols="3">
              <v-card class="elevation-12" to={{ name: "consent-student" }}>
                <v-toolbar color="green">
                  <v-spacer></v-spacer>
                  <v-toolbar-title class="text-center">Student</v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-actions class="justify-center">
                  <v-btn fab icon x-large to={{ name: "consent-student" }}>
                    <v-icon x-large>mdi-file-document-box</v-icon>
                  </v-btn>
                </v-card-actions>
                <v-card-text>If you are a student, click here.</v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-container>
    );
  }
}

const component = Selection;
